const languageSelectors = document.querySelectorAll('.language-selector__details');

document.addEventListener('click', (event) => {
    languageSelectors.forEach((details) => {
        if (!details.contains(event.target)) {
            details.removeAttribute('open');
        }
    });
});